import RecoverPasswordPanel from './components/RecoverPasswordPanel/RecoverPasswordPanel';

const RecoverPassword = () => <RecoverPasswordPanel />;

export default RecoverPassword;
